var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 268,
    viewBox: "0 0 244 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.328 267.423C180.278 258.904 197.088 246.263 210.532 230.421C223.976 214.58 233.714 195.938 239.038 175.855C244.361 155.771 245.135 134.753 241.303 114.333C237.47 93.9121 229.129 74.6044 216.886 57.8175C204.644 41.0307 188.809 27.1879 170.536 17.2987C152.264 7.40956 132.014 1.72334 111.265 0.654761C90.5153 -0.413816 69.789 3.16218 50.5972 11.122C31.4055 19.0817 14.2323 31.2246 0.329944 46.665L59.2547 99.72C65.2615 93.0486 72.6816 87.8019 80.9739 84.3627C89.2661 80.9235 98.2214 79.3784 107.187 79.8401C116.152 80.3018 124.901 82.7587 132.796 87.0315C140.691 91.3044 147.533 97.2855 152.823 104.539C158.113 111.792 161.717 120.134 163.373 128.957C165.029 137.78 164.694 146.862 162.394 155.539C160.094 164.217 155.886 172.272 150.078 179.116C144.269 185.961 137.006 191.423 128.818 195.104L161.328 267.423Z",
    fill: "#EAF1EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubBack);
export default __webpack_public_path__ + "static/media/sub_back.2382b4f27042e9630ea3174be04549f1.svg";
export { ForwardRef as ReactComponent };